import {ChangeDetectionStrategy, Component, Input} from '@angular/core';

@Component({
    selector: 'ngx-loading',
    templateUrl: './loading.component.html',
    styleUrls: ['./loading.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    preserveWhitespaces: false
})
export class NgxLoading {

    /**
     * The width of the loader.
     */
    @Input() width = '80px';

    /**
     * The height of the loader.
     */
    @Input() height = '80px';

    /**
     * The spacing of the loader.
     */
    @Input() spacing = '20px';

    /**
     * The stroke width of the loader.
     */
    @Input() strokeWidth = 8;

    /**
     * The color of the loader.
     */
    @Input() color = '#de1522';

}
